import type { FC, PropsWithChildren } from 'react';
import { createContext, useContext, useEffect, useState } from 'react';

interface Props {
  setTitle: (value: string | undefined) => void;
  title: string | undefined;
}

const TitleContext = createContext<Props | undefined>(undefined);

export const TitleProvider: FC<PropsWithChildren> = ({ children }) => {
  const [title, setTitle] = useState<string | undefined>();
  return (
    <TitleContext.Provider value={{ setTitle, title }}>
      {children}
    </TitleContext.Provider>
  );
};

export const useTitle = (): string | undefined =>
  useContext(TitleContext)?.title;

export const useSetTitle = (title?: string): void => {
  const props = useContext(TitleContext);
  // biome-ignore lint/correctness/useExhaustiveDependencies: working, don't mess with it
  useEffect(() => {
    console.log(`Setting title to: ${title ?? 'undefined'}`);
    document.title = title ? `${title} - Patrol Roster` : 'Patrol Roster';
    props?.setTitle(title);
  }, [title]);
};

export const SetTitle: FC<Props> = ({ title }) => {
  useSetTitle(title);
  return null;
};
